// Libs
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
import { Loading } from '~/components/common';
// Others
import { formatDate } from '~/utils/helper/common';
import { EMPTY_STRING } from '~/utils/constants/common';
import { IOverbooking } from '~/utils/interface/statistic';
import { DateFormatEnum } from '~/utils/enum/common';
import { useAppDispatch } from '~/utils/redux/hooks';
import { getStatisticOverbookingItem } from '~/thunks/statistic/statisticThunk';
// Styles, images, icons
import styles from './Overbookings.module.scss';
import { icons } from '~/assets';

type Props = {};

const cx = classNames.bind(styles);

const Overbookings = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/dashboard']);
  const dispatch = useAppDispatch();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [listOverbooking, setListOverbooking] = useState<IOverbooking[]>([]);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    handleGetListOverbooking();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion Implement Hook

  //#region Handle Function
  const handleGetListOverbooking = () => {
    setIsLoading(true);

    dispatch(getStatisticOverbookingItem())
      .unwrap()
      .then((res) => {
        const { data } = res;

        const convertData = data.map((item) => ({ ...item, variantName: item?.variantName || EMPTY_STRING }));

        if (!convertData) return;

        setListOverbooking(convertData);
      })
      .catch((_error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };
  //#endregion Handle Function

  return (
    <Box id='overbookingsComponent' className={cx('container')}>
      <Stack direction={'row'} spacing={'13px'} justifyContent={'space-between'} justifyItems={'center'}>
        <Typography className={cx('title')}>{t('dashboard_title_overbookings')}</Typography>

        <Stack className={cx('viewAlert')}>
          <img
            src={icons.commonIconError}
            alt={t('altImg', {
              ns: 'common/base',
            })}
            className={cx('iconAlert')}
          />

          <Typography className={cx('textAlert')}>
            {t(listOverbooking.length > 1 ? 'overbooking_title_alerts' : 'overbooking_title_alert', {
              value: listOverbooking.length,
            })}
          </Typography>
        </Stack>
      </Stack>

      <Stack className={cx('content')}>
        {listOverbooking && listOverbooking.length > 0 ? (
          listOverbooking.map((item, index) => (
            <Stack key={index} className={cx('itemOverbooking')}>
              <Stack direction={'column'} gap={1}>
                <Typography className={cx('titleItem')}>{`${item?.name} ${
                  item?.variantName && `- ${item?.variantName}`
                }`}</Typography>

                <Stack direction={'row'} gap={2} alignItems={'center'}>
                  <img
                    src={icons.commonIconCalendar}
                    alt={t('altImg', {
                      ns: 'common/base',
                    })}
                    className={cx('iconDate')}
                  />

                  <Typography className={cx('dateItem')}>
                    {t('overbooking_title_sub_date', {
                      number: Number(item?.overbookedQuantity) - Number(item?.subRentalQuantity),
                      value: formatDate(item?.startDate, DateFormatEnum.MMM_D_YYYY),
                    })}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          ))
        ) : (
          <Typography align='center' className={cx('noData')}>
            {t('common_no_data_available', { ns: 'common/base' })}
          </Typography>
        )}
      </Stack>

      {isLoading && <Loading />}
    </Box>
  );
};

export default Overbookings;
